import React, { useCallback } from 'react';
import { useLocalizedImages } from '@strava/react-hooks/src/use-localized-images';
import { useStravaBranch } from '@strava/container-context';
import Badge from './components/Badge';
import { APP_STORES, APP_STORE_BADGE_SIZES } from './constants';
import { mobileOsToAppStore } from './helpers';

import {
  useStravaErrorLogging,
  useStravaTranslations
} from '@strava/container-context';

const AppStoreBadges = ({ track, className, userAgent }) => {
  const { t, getLanguage } = useStravaTranslations();
  const locale = getLanguage();

  const { logError } = useStravaErrorLogging();
  const { appLink } = useStravaBranch();

  // Note: Example path (locale provided) - './media/de-DE/app-store-de-DE@1x.png`
  const importBadgeImage = useCallback(
    async ({
      imageLocaleDirectory,
      imageKey,
      imageFormat,
      imageResolution,
      imageLocale
    }) => {
      // Create dynamic path to file
      const path = `${imageLocaleDirectory}/${imageKey}-${
        imageLocale ? `${imageLocale}` : ''
      }@${imageResolution}.${imageFormat}`;

      try {
        // Import file
        return (
          await import(
            /* webpackMode: "eager" */
            /* webpackExports: ["default", "named"] */
            `./media/${path}`
          )
        ).default;
      } catch (error) {
        logError(error);
        return null;
      }
    },
    [logError]
  );

  const appleBadgeImages = useLocalizedImages({
    key: 'app-store',
    locale,
    imageImportCallback: importBadgeImage,
    logError,
    sizes: APP_STORE_BADGE_SIZES
  });

  const googleBadgeImages = useLocalizedImages({
    key: 'play-store',
    locale,
    imageImportCallback: importBadgeImage,
    logError,
    sizes: APP_STORE_BADGE_SIZES
  });

  const appStore = mobileOsToAppStore(userAgent);

  return (
    <ul className={className}>
      {[APP_STORES.apple, APP_STORES.unknown].includes(appStore) && (
        <li>
          <Badge
            badge={{
              id: APP_STORES.apple,
              url: appLink,
              isLazy: true,
              images: appleBadgeImages,
              alt: t('shared_ui.alt.apple_store_badge')
            }}
            track={track}
          />
        </li>
      )}
      {[APP_STORES.google, APP_STORES.unknown].includes(appStore) && (
        <li>
          <Badge
            badge={{
              id: APP_STORES.google,
              url: appLink,
              isLazy: true,
              images: googleBadgeImages,
              alt: t('shared_ui.alt.google_store_badge')
            }}
            track={track}
          />
        </li>
      )}
    </ul>
  );
};

export default AppStoreBadges;
